<template>

  <v-number-input
    :label="$t('titles.default_cost')"
    prefix="$"
    :precision="2"
    :rules="rules"
    v-model="defaultRate.defaultCost"
    :density="density"
    :hint="hint"
    :disabled="disabled"
    :hide-details="hideDetails"
  >

    <template v-if="showId" v-slot:prepend-inner>
      <div class="text-disabled text-body-2 mr-2">
        DR<br>
        {{ defaultRate.id }}
      </div>
    </template>

    <template v-if="collapsible" v-slot:append>
      <v-btn
        :icon="collapsed ? '$expand' : '$collapse'"
        @click="$emit('update:collapsed', !collapsed)"
        :density="density"
      />
    </template>

  </v-number-input>

</template>

<script setup lang="ts">

/**
 * Field for editing a single DefaultRate.
 */

import { dollarAmount, minValue, required } from '../../../validation'
import type { DefaultRateFieldState } from '../../../types/misc'

interface Props {
  clearable?: boolean
  showId?: boolean
  disabled?: boolean
  collapsible?: boolean
  collapsed?: boolean
  density?: null | 'compact' | 'default' | 'comfortable'
  hint?: string
  hideDetails?: boolean
}

withDefaults(defineProps<Props>(), {
  clearable: true,
  showId: true,
  disabled: false,
  collapsible: false,
  collapsed: false,
  density: null,
  hideDetails: false,
})

defineEmits(['update:collapsed'])

const rules = [required(), dollarAmount(), minValue(0.01)]

const defaultRate = defineModel<DefaultRateFieldState>({required: true})

</script>
